import { combineReducers } from 'redux';
import { ACTIONS } from '../../_config';

import loaderReducer from './loaderReducer';
import userReducer from './userReducer';
import dialogReducer from './dialogReducer';
import masterReducer from './masterReducer';

const appReducer = combineReducers({
	loader: loaderReducer,
	user: userReducer,
	dialog:dialogReducer,
	master: masterReducer
})

const rootReducer = (state: any, action: any) => {
	if (action.type === ACTIONS.USER.LOGOUT) {
		state = undefined;
		localStorage.removeItem('persist:root');
	}

	return appReducer(state, action)
	
}

export default rootReducer